import React, { useEffect, useRef, useState } from 'react';

import {
  AddressType, AvCheckFormData, CmsPageContentIdentifier,
  CmsPageContentType, HouseholdConfigurationType,
  ReduxStateType, TechBuildingPart, UsageType,
} from '@/types/av-check';
import { connect } from 'react-redux';
import AlertBox from '@/components/av-check/AlertBox';
import DtagFtthAlertBox from '@/components/av-check/AlertBox/DtagFtthAlertBox';

export interface StateProps {
  cmsContent : CmsPageContentType,
  address? : AddressType,
  householdConfig?:HouseholdConfigurationType
}

interface DtagSpecificationViewProps {
  onAvailabilityCheck : (requestBody: AvCheckFormData) => void,
  onCheckAnotherAddress : () => void,
  setShowDTAGSpecificationView: (showDTAGSpecificationView:boolean) => void,
  setDtagSpecificAvChecked: (dtagSpecificAvCheck:boolean) => void,
  isDtagGuiEnhancementsToggleEnabledForShop : boolean,
  isDtagGuiEnhancementsToggleEnabledForCci : boolean
}

const DtagSpecificationView = (
  {
    cmsContent,
    address,
    householdConfig,
    onAvailabilityCheck,
    onCheckAnotherAddress,
    setShowDTAGSpecificationView,
    setDtagSpecificAvChecked,
    isDtagGuiEnhancementsToggleEnabledForShop,
    isDtagGuiEnhancementsToggleEnabledForCci,
  }: StateProps & DtagSpecificationViewProps,
) => {

  if (!address) {
    return null;
  }

  const [buildingPartSelectionName, setBuildingPartSelectionName]  = useState('');
  const [buildingPartSelectionId, setBuildingPartSelectionId]  = useState('');
  const isDtagGuiEnhancementsToggleEnabled =
        isDtagGuiEnhancementsToggleEnabledForShop || isDtagGuiEnhancementsToggleEnabledForCci;
  const [connectionExists, setConnectionExists] = useState<boolean | undefined>(isDtagGuiEnhancementsToggleEnabled ? undefined : true);
  const [showConnectionStatusError, setShowConnectionStatusError] = useState(false);
  const [buildingPartValidationErrorMessage, setBuildingPartValidationErrorMessage ]  = useState('');
  const [errorStylingFlag, setErrorStylingFlag ]  = useState(false);


  const css = `
            .continue-btn{
  display: block !important; 
  text-align: right !important;
  }
  .custom-text-margin p {
    margin : 0px !important;
  }
            `;

  const validationForConnectionStatusAndBuildingPart = (): boolean => {
    if (isDtagGuiEnhancementsToggleEnabled) {
      let connectionExistsValidation = connectionExists == undefined;
      let buildingPartValidation = address.buildingParts && address.buildingParts.length > 0 && !buildingPartSelectionId;

      if (connectionExistsValidation) {
        setShowConnectionStatusError(true);
      }
      if (buildingPartValidation) {
        setBuildingPartValidationErrorMessage(cmsContent[CmsPageContentIdentifier.BuildingPartValidationError]);
        setErrorStylingFlag(true);
      }
      return !connectionExistsValidation && !buildingPartValidation;
    } else {
      return true;
    }
  };

  const toggleConnectionExists = (value : boolean) => {
    setDtagSpecificAvChecked(false);
    setConnectionExists(value);
    setShowConnectionStatusError(false);
  };

  const noDtagFtthAvailable = buildingPartSelectionId && (address.buildingParts.find(bp => bp.buildingPartId === buildingPartSelectionId)!.expansionStatus == 'notPlanned');
    const buildingPartSelection = () => {
    const buildingPartInput = useRef(null);
        useEffect(() => {
      if (buildingPartInput != null && buildingPartInput.current != null) {
        // @ts-ignore
        buildingPartInput.current.focus();
      }
    });
    return (
        <>
            <div className="row">
                <div className="row">
                    <div className="margin-top-md" style={{ paddingLeft: '1.2em', marginBottom: '20px' }}>
                        <div
                            dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalBuildingPartId] }}/>
                    </div>
                </div>
                <div className={`${isDtagGuiEnhancementsToggleEnabled ? 'input size-xs' : 'row'}`}>
                    <div className="col-xs-12 col-sm-12 col-lg-5 col-md-5 col-sm-offset-1">
                        <span className={`nice-select ${errorStylingFlag ? 'input size-xs has-error' : ''}`}>
                            <select
                                ref={buildingPartInput}
                                className="form-control"
                                name="buildingPartSelection"
                                defaultValue="Bitte-waehlen"
                                onChange={(e) => {
                                  const selectedOption = e.target.selectedOptions.length > 0 ? e.target.selectedOptions[0] : null;
                                  if (selectedOption) {
                                    setBuildingPartSelectionName(selectedOption.value);
                                    setBuildingPartSelectionId(selectedOption.id);
                                    setDtagSpecificAvChecked(false);
                                    setBuildingPartValidationErrorMessage('');
                                    setErrorStylingFlag(false);
                                  }
                                }}>
                                  <option value="Bitte-waehlen">Bitte wählen</option>
                                {
                                    address.buildingParts.map(function (item) {
                                      return <option id={item.buildingPartId}>{item.buildingPartName}</option>;
                                    })
                                }
                              </select>
                            </span>
                        <div className="input size-xs has-error">
                            <div className="help-block"
                                 dangerouslySetInnerHTML={{ __html: buildingPartValidationErrorMessage }}/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
  };

    const checkAnotherAddress = () => {
            return (
                <a
                    className="link-icon-left link-bold"
                    onClick={onCheckAnotherAddress}
                >
                    <span className="glyphicon glyphicon-arrow-left" />
                    <span dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.CheckOtherAddressLink] }} />
                </a>
            );
    };

  const showNoDtagFtthAlertWithCheckAnotheAddress = () => (
        <div className="row">
            <div className="col-sm-offset-1">
                <div className="row">
                    <div className="col-xs-10 col-sm-10 margin-top-lg"
                         style={{ border: '2px solid transparent', borderColor: '#ff7947', padding: '10px 10px 10px 10px' }}>
                        <AlertBox
                            type="warning"
                            contentParams={{ ...address }}
                            contentIdentifier={CmsPageContentIdentifier.GlassfaserModalAertMessage}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="margin-top-lg">
                        {checkAnotherAddress()}
                    </div>
                </div>
            </div>
        </div>
  );

    const dtagEnhancementElement = () => (
      <>
          <style>
              {css}
          </style>
      <div className="custom-text-margin" >
          <div className="row">
                <div style={{ paddingLeft: '1.5em' }}>
                    <div
                        dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalFtthEnhancementAdditionalText] }}/>
                </div>
            </div>
            <div className="row" style={{ padding : '20px', display: showConnectionStatusError ? 'block' : 'none' }}>
                <div
                    className="col-sm-offset-1 col-xs-12 col-sm-12 col-lg-7 col-md-7">
                    <DtagFtthAlertBox
                        type="danger"
                        contentIdentifier={CmsPageContentIdentifier.GlassfaserModalRadioButtonValdation}
                    />
                </div>
            </div>
            <div className="row" style={{ paddingLeft: '1.2em' }}>
                <div className="radio col-sm-offset-1" onChange={() => toggleConnectionExists(true)}>
                    <input type="radio" name="isExistingConnection" id="ja_ExistingConnection"
                           checked={connectionExists != undefined ? connectionExists : false}/>
                    <label htmlFor="ja_ExistingConnection"
                           dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalRadioButtonTextYes] }}/>
                </div>
            </div>
            <div className="row" style={{ paddingLeft: '1.2em' }}>
                <div className="radio col-sm-offset-1" style={{ marginTop: '10px' }}
                     onChange={() => toggleConnectionExists(false)}>
                    <input type="radio" name="isExistingConnection" id="Nein_ExistingConnection"
                           checked={connectionExists != undefined ? !connectionExists : false}/>
                    <label htmlFor="Nein_ExistingConnection"
                           dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalRadioButtonTextNo] }}/>
                </div>
                <div className="continue-btn" style={{ textAlign: 'right' }}>
                    {noDtagFtthAvailable ? toHtsTariffsButton() : continueButton()}
                </div>
            </div>
        </div>
      </>
  );

  const glasfaserModalRadio = () => (
        <>
            <div>
                <div className="row" style={{ paddingLeft: '1.2em' }}>
                    <div className="radio col-sm-4 col-sm-offset-1" onChange={() => toggleConnectionExists(true)}>
                        <input type="radio" name="isExistingConnection" id="ja_ExistingConnection"
                               checked={connectionExists}/>
                        <label htmlFor="ja_ExistingConnection">Ja</label>
                    </div>
                    <div className="radio col-sm-4" style={{ paddingTop: '15px' }} onChange={() => toggleConnectionExists(false)}>
                        <input type="radio" name="isExistingConnection" id="Nein_ExistingConnection"
                               checked={!connectionExists}/>
                        <label htmlFor="Nein_ExistingConnection"> Nein/Ich weiB nicht</label>
                    </div>
                </div>
                <div className="row">
                    <div style={{ paddingLeft: '1.5em' }}>
                        <div
                            dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalFtthAdditionalText] }}/>
                    </div>
                </div>
            </div>
        </>
  );

  const backButtonHandler = () => {
    setShowDTAGSpecificationView(false);
  };
  const onAvCheckWithBuildingParts = () => {
    if (validationForConnectionStatusAndBuildingPart()) {
      let selectedBuildingPart: TechBuildingPart = {
        buildingPartId: buildingPartSelectionId,
        buildingPartName: buildingPartSelectionName,
        expansionPeriodEnd: '',
        expansionPeriodStart: '',
        expansionStatus: '',
      };

      let dataForAvcheck: AvCheckFormData = {
        zipCode: address.zipCode,
        city: address.city,
        houseNumber: address.houseNumber,
        street: address.street,
        corrected: address.corrected,
        numberOfPersons: householdConfig?.personInHousehold ? householdConfig.personInHousehold.toString() : '',
        usageTypeOnlineGaming: householdConfig?.personInHousehold ? householdConfig.usageTypes.includes(UsageType.GAMING) : false,
        usageTypeVideoStreaming: householdConfig?.personInHousehold ? householdConfig.usageTypes.includes(UsageType.STREAMING) : false,
        usageTypeHomeOffice: householdConfig?.personInHousehold ? householdConfig.usageTypes.includes(UsageType.HOME_OFFICE) : false,
        buildingParts: selectedBuildingPart,
        isFiberExtensionAvailable: connectionExists,
        buildingPartId: buildingPartSelectionId,
      };
      setDtagSpecificAvChecked(true);
      onAvailabilityCheck(dataForAvcheck);
    }
  };

  const disableContinueButton = () => {
    return isDtagGuiEnhancementsToggleEnabled ? false : address.buildingParts && address.buildingParts.length > 0 && !buildingPartSelectionId;
  };

  const continueButton = () => (
      <button className={`btn btn-alpha ${disableContinueButton() ? 'disabled' : ''}`}
              disabled={disableContinueButton()}
              type="button"
              onClick={onAvCheckWithBuildingParts}
      >
          Weiter mit Glasfaser
      </button>
  );

  const toHtsTariffsButton = () => (
      <a className="btn"
         type="button"
         href="internet-festnetz"
      >
          Zu den Tarifen
      </a>
  );

  return (
        <>
        <div className="modal-availability-check">
            <div className="modal-dialog modal-lg modal-has-header modal-has-footer">
                    <div className="modal-content">
                        <div className="modal-header" style={{ background: 'white' }}>
                            <h3 className="modal-title"
                                dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalHeader] }}/>
                        </div>
                        <div className="dtag-description">
                            {address.buildingParts.length > 0 && buildingPartSelection()}
                            {noDtagFtthAvailable ?
                              (<div>
                                    {showNoDtagFtthAlertWithCheckAnotheAddress()}
                                 </div>) :
                              (<div>
                                    {address.buildingParts.length > 0 && <hr/>}
                                    <div className="row">
                                        <div className="row">
                                            <div style={{ paddingLeft: '1.5em' }}>
                                                <div
                                                    dangerouslySetInnerHTML=
                                                        {{ __html: cmsContent[CmsPageContentIdentifier.GlassfaserModalAvailabilityRadioText] }}/>
                                            </div>
                                        </div>
                                        {isDtagGuiEnhancementsToggleEnabled ? dtagEnhancementElement() : glasfaserModalRadio()}
                                        <div className="row">
                                            <div className="margin-top-lg" style={{ paddingLeft: '1.5em' }}>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html:
                                                            cmsContent[CmsPageContentIdentifier.GlassfaserModalDoseIllustrationText] }}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
  );
};

const mapStateToProps = (state: ReduxStateType) => ({
  cmsContent: state.cmsContent,
  address: state.result?.address,
  householdConfig: state.result?.householdConfiguration,
});

export default connect(mapStateToProps)(DtagSpecificationView);
